/*
 * @Author: wufei
 * @Date: 2020-08-07 11:01:31
 * @LastEditTime: 2020-08-13 11:30:08
 * @Description:
 * @FilePath: \mobile-revive\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect() {
                return '/index'
            }
        },
        {
            path: '/index',
            name: 'index',
            component: () => import('@/views/index'),
            meta: {
                title: '复盘大数据'
            }
        },
        {
            path: '/report',
            name: 'report',
            component: () => import('@/views/report'),
            meta: {
                title: '复盘报告'
            }
        },
        {
            path: '/views/exam/replayApproval',
            name: 'replayApproval',
            component: () => import('@/views/exam/replayApproval'),
            meta: {
                title: '复盘审批'
            }
        },
        {
            path: '/exam/addRecord',
            name: 'addBack',
            component: () => import('@/views/exam/addBack'),
            meta: {
                title: '复盘补录审批'
            }
        }
    ]
})
